<template>
    <transition name="fade">
        <div :class="['pill', 'bold', 'py-3', 'px-4', 'text-center', pill.status]">
            {{ pill.message }}
        </div>
    </transition>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        created: function() {
            this.hidePill();
        },
        methods: {
            ...mapActions([
                'hidePill'
            ])
        },
        computed: {
            ...mapGetters([
                'getPill',
            ]),
            pill: function() {
                return this.getPill;
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables.scss';

    .pill {
        position: absolute;
        top: 1rem;
        left: 48%;
        border-radius: 40px;
        z-index: 1;

        &.success {
            color: $lightest;
            background: $color-3;
        }

        &.error {
            color: $lightest;
            background: $brand;
        }
    }
</style>


// WEBPACK FOOTER //
// Pill.vue?7e76a8a1